import { ControlProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { HubBrief } from './hub.model';
import { Validators } from '@angular/forms';
import { NUMBER_PATTERN, PHONE_NUMBER_PATTERN } from '../../../../../common/constants/validation-rules';
import { ListQueryParam } from '../../../../../common/constants';
import { LocalDate } from '../../../../models';
import { mustNotBeBlankValidator } from '../../../../../common/utils';

interface HubLoanerPhoneListItemDriverHistory {
  issued: LocalDate;
  lastLoanedTo: string;
  returned: LocalDate;
}

export class HubLoanerPhoneListItem extends HubBrief {
  available: boolean;
  driverName: string;
  hubId: number;
  id: number;
  extId: string;
  imei: string;
  loaned = false;
  loanedFrom: number;
  manufacturer: string;
  model: string;
  note: string;
  phoneNumber: string;
  truckPlate: string;

  history: HubLoanerPhoneListItemDriverHistory[];

  constructor(params?: HubLoanerPhoneListItem) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class HubLoanerPhoneListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: HubLoanerPhoneListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class HubLoanerPhoneForm {
  constructor(
    phone: HubLoanerPhoneListItem,
    public available: ControlProperty<boolean> = phone.available,
    public manufacturer: ControlProperty<string> = [phone.manufacturer, [Validators.required, mustNotBeBlankValidator]],
    public id: ControlProperty<number> = phone.id,
    public extId: ControlProperty<string> = [
      phone.extId,
      [Validators.required, Validators.pattern(NUMBER_PATTERN), mustNotBeBlankValidator],
    ],
    public imei: ControlProperty<string> = [phone.imei, [Validators.required, mustNotBeBlankValidator]],
    public loaned: ControlProperty<boolean> = phone.loaned,
    public phoneNumber: ControlProperty<string> = [
      phone.phoneNumber,
      [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)],
    ],
    public model: ControlProperty<string> = [phone.model, [Validators.required, mustNotBeBlankValidator]],
    public truckPlate: ControlProperty<string> = phone.truckPlate,
    public driverName: ControlProperty<string> = phone.driverName,
    public note: ControlProperty<string> = phone.note,
  ) {}
}
